import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
    name: 'CmgAutoAccrualErrorModal',
})
export default class CmgAutoAccrualErrorModal extends Vue {
    get visible(): boolean {
      return this.$appStore.state.ui.modals.autoAccrualErrorModal.visible;
    }

    get args() {
      return this.$appStore.state.ui.modals.autoAccrualErrorModal.args;
    }

    get header(): string | null {
      return (this.args && this.args.header) || null;
    }

    get content(): string | null {
      return (this.args && this.args.content) || null;
    }

    get options() {
      return (this.args && this.args.options) || [];
    }

    onClickOption(option: { onClick: () => void | Promise<any> }) {
			option.onClick();
			this.$services.ui.focusBack();
    }

    onClose() {
      this.$services.ui.setModalVisibility('autoAccrualErrorModal', false);
    }
}

